import { useState } from 'react'

import { useLocation } from 'react-router'

import { useIsInvitationFormFlow } from '@app/hooks/useIsInvitationFormFlow'
import { Step } from '@app/types/steps'
import { TRACKING_FLOW_TYPE, TRACKING_STEP, trackPage } from '@app/utils/tracking'

export const flowType: string[] = ['CARD', 'EMAIL', 'MAIL'] as const
export type FlowType = (typeof flowType)[number]

export type useStepsNavigation = {
  currentStep: Step
  hasNextStep: boolean
  hasPreviousStep: boolean
  activeStepNumber: number
  reset: () => void
  goToNextStep: () => void
  goToPreviousStep: () => void
}

type UseStepsParams = {
  params?: {
    isUserSSO?: boolean
  }
  steps: Step[]
  firstActiveStepNumber?: number
}

export const useSteps = ({ steps, firstActiveStepNumber }: UseStepsParams): useStepsNavigation => {
  const [activeStepNumber, setActiveStepNumber] = useState(firstActiveStepNumber ?? 0)
  const hasNextStep = activeStepNumber < steps.length - 1
  const hasPreviousStep = activeStepNumber - 1 >= 0

  const location = useLocation()
  const { origin } = useIsInvitationFormFlow()

  return {
    reset: () => setActiveStepNumber(0),
    goToNextStep: () => {
      const newStepNumber = activeStepNumber + 1
      setActiveStepNumber(newStepNumber)

      trackPage(`${location.pathname}/${TRACKING_FLOW_TYPE[origin]}/${TRACKING_STEP[steps[newStepNumber]]}`)
    },
    goToPreviousStep: () => {
      const newStepNumber = activeStepNumber - 1
      setActiveStepNumber(newStepNumber)

      trackPage(`${location.pathname}/${TRACKING_FLOW_TYPE[origin]}/${TRACKING_STEP[steps[newStepNumber]]}`)
    },
    currentStep: steps[activeStepNumber],
    activeStepNumber,
    hasNextStep,
    hasPreviousStep,
  }
}
